"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _planHeader = _interopRequireDefault(require("./planHeader"));
var _ChangeTariffButton = _interopRequireDefault(require("./ChangeTariffButton"));
var _planInclusions = _interopRequireDefault(require("./cardContent/planInclusions"));
var _bundlePlanDetails = _interopRequireDefault(require("./cardContent/bundlePlanDetails"));
var _constants = require("../constants");
var _WrapByDataAttributes = _interopRequireDefault(require("../utils/WrapByDataAttributes"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _DiscountSection = _interopRequireDefault(require("./DiscountSection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BundlePlan = function BundlePlan() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state[_constants.PKG_NAME];
    }),
    inclusions = _useSelector.inclusions;
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$activePlan = _useConfig.activePlanSchema,
    _useConfig$activePlan2 = _useConfig$activePlan === void 0 ? {} : _useConfig$activePlan,
    planHeaderSection = _useConfig$activePlan2.planHeaderSection,
    PlanInclusionsSection = _useConfig$activePlan2.PlanInclusionsSection,
    BundlePlanDetailsSection = _useConfig$activePlan2.BundlePlanDetailsSection,
    DiscountsSection = _useConfig$activePlan2.DiscountsSection,
    managePlanBtn = _useConfig$activePlan2.managePlanBtn;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (planHeaderSection === null || planHeaderSection === void 0 ? void 0 : planHeaderSection.isShown) && /*#__PURE__*/_react.default.createElement(_planHeader.default, null), inclusions && (PlanInclusionsSection === null || PlanInclusionsSection === void 0 ? void 0 : PlanInclusionsSection.isShown) && /*#__PURE__*/_react.default.createElement(_WrapByDataAttributes.default, {
    "data-testid": "plan-inclusions"
  }, /*#__PURE__*/_react.default.createElement(_planInclusions.default, null)), (BundlePlanDetailsSection === null || BundlePlanDetailsSection === void 0 ? void 0 : BundlePlanDetailsSection.isShown) && /*#__PURE__*/_react.default.createElement(_bundlePlanDetails.default, null), (DiscountsSection === null || DiscountsSection === void 0 ? void 0 : DiscountsSection.isShown) && /*#__PURE__*/_react.default.createElement(_DiscountSection.default, null), (managePlanBtn === null || managePlanBtn === void 0 ? void 0 : managePlanBtn.isShown) && /*#__PURE__*/_react.default.createElement(_ChangeTariffButton.default, null));
};
var _default = BundlePlan;
exports.default = _default;